import React from 'react';
import { string, number, object } from 'prop-types';
import { Rating } from '@fiverr-private/orca';

const RatingWrapper = (
    { className, rating = 0, ratingsCount, onClick },
    { general: { isPro } }
) => (
    <Rating className={className}
        score={parseFloat(rating.toFixed(1))}
        color={isPro ? Rating.COLORS.PRO: Rating.COLORS.YELLOW}
        ratingsCount={ratingsCount}
        onClick={onClick}/>
);

RatingWrapper.propTypes = {
    className: string,
    rating: number,
    ratingsCount: number
};

RatingWrapper.contextTypes = {
    general: object
};

export default RatingWrapper;
